import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "swiper/modules";
import Modal from "react-modal";

interface FullScreenSwiperProps {
  isOpen: boolean;
  onClose: () => void;
  images: string[];
}

const FullScreenSwiper: React.FC<FullScreenSwiperProps> = ({
  isOpen,
  onClose,
  images,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="Full Screen Swiper"
      className="modal-full-screen"
      overlayClassName="overlay"
    >
      <button
        onClick={onClose}
        className="close-button absolute w-[3.125rem] h-[3.125rem] top-[3.75rem] right-[5rem] bg-[rgba(255, 255, 255, 0.8)]"
      >
        <img src="../../../assets/icons/close.svg" alt="Close" />
      </button>
      <div>
        <Swiper
          slidesPerView={1}
          centeredSlides={true}
          spaceBetween={30}
          loop={true}
          navigation={{
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          }}
          modules={[Pagination, Navigation]}
          className="full-screen-swiper"
        >
          {images.map((src, index) => (
            <SwiperSlide key={index}>
              <img className="object-cover" src={src} alt={`Slide ${index}`} />
            </SwiperSlide>
          ))}
        </Swiper>
        <div className="swiper-button-prev custom-swiper-button-prev">
          <img src="../../../assets/icons/prev-arrow-white.svg" alt="" />
        </div>
        <div className="swiper-button-next custom-swiper-button-next">
          <img src="../../../assets/icons/next-arrow-white.svg" alt="" />
        </div>
      </div>
    </Modal>
  );
};

export default FullScreenSwiper;
